import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const ProtectedRoute = ({...props}) => {
    return localStorage.getItem('userid') ? <Route {...props} / > : <Redirect to='/login' />
}

export default ProtectedRoute;